import { Component, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbThemeService, NbDialogService, NbDialogRef } from '@nebular/theme';


import { LocalDataSource } from 'ng2-smart-table';

import { ProduitService } from '../../../@core/data/rest/produit/produit-service';
import { Produit } from '../../../@core/data/model/produit';
import { FactureService } from '../../../@core/data/rest/facture/facture-service';
import { Facture } from '../../../@core/data/model/facture';
import {PartenaireService } from '../../../@core/data/rest/partenaire/partenaire-service';
import {Partenaire } from '../../../@core/data/model/partenaire';

import {plainToClass} from 'class-transformer';
import {NgbDateStruct, NgbCalendar, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { isDefined } from '@ng-bootstrap/ng-bootstrap/util/util';
import { FluxStock } from '../../../@core/data/model/fluxstock';
import { FluxStockService } from '../../../@core/data/rest/fluxstock/fluxstock-service';
import { Reglement } from '../../../@core/data/model/reglement';
import { ReglementService } from '../../../@core/data/rest/reglement/reglement-service';
import { ReglementFormComponent } from '../reglementform/reglementform.component';
import { Validator } from '../../../@core/data/model/validator';
import { PartenaireFormComponent } from '../../partenaire/partenaireform/partenaireform.component';
import swal from 'sweetalert2';

import { NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../../auth/auth.service';
import { Commande } from '../../../@core/data/model/commande';
import { CommandeFormComponent } from '../commandeform/commandeform.component';
import { Bordereau } from '../../../@core/data/model/bordereau';
import { EditFormModalBordereauComponent } from '../../bordereau/function/editbordereauform.modal.component';
import { BordereauService } from '../../../@core/data/rest/bordereau/bordereau-service';
import { Subscriber, Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CashSession } from '../../../@core/data/model/cashsession';
import { CashSessionService } from '../../../@core/data/rest/caisse/cashsession-service';
import { SessionFormComponent } from '../../caisse/form/sessionform.component';
import { TaxeService } from '../../../@core/data/rest/taxe/taxe-service';
import { Taxe } from '../../../@core/data/model/taxe';
import { TaxeFormComponent } from '../../setting/settingform/taxeform.component';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nb-editmodalform',
  templateUrl: './editform.modal.component.html' ,
  styleUrls: ['./editform.modal.component.scss'],
})
export class EditFormModalComponent implements OnDestroy {


  @Input() name;
  @Input() rowData: any;
  @Input() facture: Facture;
  @Input() commandes: Commande[];
  @Input() bordereauxL: Bordereau[];
  @Input() bordereauxR: Bordereau[];
  @Input() reglements: Reglement[];
  @Input() typeEdit: string;

  modalRef: NgbModalRef;

  private alive = true;

  datefacture: NgbDateStruct;
  echeanceFacture: NgbDateStruct;
  data: Produit[];

  validate = false;

  produitloading: boolean;
  fluxstockedit: FluxStock;
  reglementEdit: Reglement;
  typePartner: string;
  typeFlux: string;
  typeFluxRetour: string;
  typeFluxReglement: string;
  natureStock: string;
  labelPartner: string;
  printlink: string;

  colspanTab = 5;

  dialogIsNotShow = false;

  partnerLoading = false;

  vendeurLoading = false;


  partenaire = new Partenaire;

  settingsBordereau: any;
  settings: any;
  commandeSettings: any;
  retourSettings: any;
  settingsReglement: any;
  editpermission = false;

  dropdownList: Partenaire[] = [];
  selectedItems = [];
  dropdownSettings = {};

  dropdownListCompte = [];
  selectedItemsCompte = [];
  dropdownSettingsCompte = {};

  dropdownListResp: Partenaire[] = [];
  selectedItemsResp = [];
  dropdownSettingsResp = {};

  sourceBordereau: LocalDataSource = new LocalDataSource();
  sourceCommande: LocalDataSource = new LocalDataSource();
  sourceRetour: LocalDataSource = new LocalDataSource();
  sourceReglement: LocalDataSource = new LocalDataSource();

  // variable totaux
  qteCommande = 0;
  qteLivrer = 0;
  qteRetour = 0;
  remise = 0;
  montantHT = 0;
  montantTVA = 0;
  montantTaxe = 0;
  montantSansLesRetours = 0;
  montantRetour = 0;
  montant = 0;
  montantReglement = 0;
  montantLivraison = 0;
  qteEmballage = 0;
  montantEmballage = 0;
  commandeEmballage: Commande[] = [];

  // subcription

  isSave = false;

  idcompte: number;

  repeatDatePart: string;
  repeatTimePart: string;

  datePart: string;
  timePart: string;

  constructor(
    public produitService: ProduitService,
    public factureService: FactureService,
    public deviceService: DeviceDetectorService,
    public cashSessionService: CashSessionService,
    public bordereauService: BordereauService,
    public partenaireService: PartenaireService,
    public taxeService: TaxeService,
    public sharedMethods: SharedMethods,
    private dialogService: NbDialogService,
    public fluxstockService: FluxStockService,
    public reglementService: ReglementService,
    public activeModal: NgbActiveModal,
    public authService: AuthService) {


      /* if (authService.token.company.active_tva ) {

        if ( authService.token.company.remise_facture )
        this.colspanTab = 6;
        else
        this.colspanTab = 5;

      } else {

        if ( authService.token.company.remise_facture )
        this.colspanTab = 5;
        else
        this.colspanTab = 3;


      } */


  }




  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit() {

    this.authService.logoutEvent.subscribe(() => {

      this.close();

    });

  
    if( (this.facture.repeat_date !== undefined && this.facture.repeat_date !== null) || (this.facture.repeat_period !== undefined && this.facture.repeat_period !== null) || this.facture.repeat_period === '' )
    this.facture.repeat = true;

    if (this.facture.repeat_date !== undefined && this.facture.repeat_date !== null) {

      const tabDate = this.facture.repeat_date.split(' ');
      this.repeatDatePart = tabDate[0];
      this.repeatTimePart = tabDate[1];

    }

    if (this.facture.date_facturation !== undefined && this.facture.date_facturation !== null) {

      const tabDate = this.facture.date_facturation.split(' ');
      this.datePart = tabDate[0];
      this.timePart = tabDate[1];

    }

    if ((this.facture.type_facture === 'vente') && this.authService.isHavingPermission(['editeInvoiceSale'])  )
    this.editpermission = true;

    if ((this.facture.type_facture === 'achat') && this.authService.isHavingPermission(['editeInvoiceBuy'])  )
    this.editpermission = true;

    if (this.facture.type_facture === 'vente') {
      this.typeFlux = 'sortie';
      this.typeFluxRetour = 'entree';
      this.typeFluxReglement = 'entree';
      this.typePartner = 'client';
      this.natureStock = 'vente';
      this.labelPartner = 'Client';
    }

    if (this.facture.type_facture === 'achat') {
      this.typeFlux = 'entree';
      this.typeFluxRetour = 'sortie';
      this.typeFluxReglement = 'sortie';
      this.typePartner = 'fournisseur';
      this.natureStock = 'achat';
      this.labelPartner = 'Fournisseur';
    }

    this.settingsBordereau = {
      actions: {
        columnTitle: '',
        position: 'left',
        add: this.editpermission,
        delete: this.editpermission,
        edit: this.editpermission, // on bloque l'édition pour faciliter ( obliger l'utilisateur à supprimer le flux pour le recréer ensuite avec une nouvelle valeur) la gestion des valeurs maximal de flux à saisir ( quantite qui depend de la quantité commandé et livré pour les retours )
      },
      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmCreate: true,
      },
      edit: {
        editButtonContent: '<i class="nb-search"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmSave: true,
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: true,
      },
      columns: {
        /* linkprint: {
          title: '',
          editable: false,
          addable: false,
          filter: false,
          type: 'custom',
          renderComponent: PrintlinkRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
        }, */
       /*  id: {
          title: 'ID',
          type: 'text',
          editable: false,
          addable: false,
          filter: true,
          width: '0px',
          class: 'coloumClass',
        }, */
        refgene: {
          title: 'Numéro ',
          type: 'text',
          filter: false,
        },
        formatDateLivraison: {
          title: 'Date',
          type: 'html',
          filter: false,
        },
        etatBordereau: {
          title: 'Etat ',
          type: 'html',
          filter: false,
        },
        quantiteLivrer: {
          title: 'Produits',
          type: 'text',
          filter: false,
        },
      },
      mode: 'external',
      noDataMessage: 'Aucun bordereau trouvé',
      pager: {
        display: true, // pour gerer la pagination
        perPage: 10,
      },
    };

    // evenment de mise à jour du tableau des livraison
    this.sourceBordereau.onChanged().subscribe( (change) => {

      /* this.sourceCommande.getFilteredAndSorted().then( (cmd: Commande[]) => {

        this.qteCommande = this.factureService.quantiteCommande(cmd);

      }); */

      this.qteLivrer = this.factureService.quantiteLivrer(this.bordereauxL);
      this.montantLivraison = this.factureService.montantLivraison(this.bordereauxL);

      /* this.montantSansLesRetours = this.factureService.montantSansLesRetours(this.commandes);
      this.montant = this.montantSansLesRetours - this.factureService.montantRetour(this.bordereauxR); */


    });


    this.commandeSettings = {
      actions: {
        columnTitle: '',
        position: 'left',
        add: this.editpermission,
        delete: this.editpermission,
        edit: false, // on bloque l'édition pour faciliter ( obliger l'utilisateur à supprimer la commande pour la recréer ensuite avec une nouvelle valeur) la gestions des ajout et rertrait d'emballage
      },

      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmCreate: true,
      },
      edit: {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmSave: true,
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: true,
      },
      columns: {
        /* id: {
          title: 'ID',
          type: 'number',
          editable: false,
          addable: false,
          filter: false,
        }, */
        nomProduit: {
          title: 'Designation',
          type: 'string',
          filter: false,
        },
        quantite: {
          title: 'Qté',
          type: 'number',
          filter: false,
        },
        prix_unitaire: {
          title: 'PU',
          type: 'number',
          filter: false,
        },
        remise: {
          title: 'REM',
          type: 'number',
          filter: false,
        },
        prixHT: {
          title: 'PHT',
          type: 'number',
          filter: false,
        },
        montantTVA: {
          title: 'TVA',
          type: 'number',
          filter: false,
          show: false,
        },
        prixTotal: {
          title: 'PT',
          type: 'number',
          filter: false,
        },
      },
      hideSubHeader: false,
      noDataMessage: 'Aucune commande effectuée',
      mode: 'external',
      pager: {
        display: false,
      },
    };

    // masquer tva

    /* if (this.commandeSettings.columns['tva'].show === false) {
      delete this.commandeSettings.columns['tva'];
    } */

    /* if (!this.authService.token.company.active_tva && !this.authService.token.company.remise_facture) {
      delete this.commandeSettings.columns['montantTVA'];
      delete this.commandeSettings.columns['prixHT'];
    }

   
    if ( !this.authService.token.company.remise_facture )
    delete this.commandeSettings.columns['remise']; */


    // evenment de mise à jour du tableau des commandes
    this.sourceCommande.onChanged().subscribe( (change) => {

      /*
      this.sourceCommande.getFilteredAndSorted().then( (cmd: Commande[]) => {

        this.qteCommande = this.factureService.quantiteCommande(cmd);

      });
      */

      this.qteCommande = this.factureService.quantiteCommande(this.commandes);
      this.remise = this.factureService.remise(this.commandes);
      this.montantHT = this.factureService.montantHT(this.commandes);
      this.montantTVA = this.factureService.montantTVA(this.commandes);
      this.montantSansLesRetours = this.factureService.montantSansLesRetours(this.commandes);
      this.commandeEmballage = this.factureService.commandeEmballage( this.commandes );
      this.qteEmballage = this.factureService.qteEmballage( this.commandeEmballage);
      this.montantEmballage = this.factureService.montantEmballage( this.commandeEmballage);

      // console.log( this.commandeEmballage );


      this.getMontantTaxe();

      /*
      this.montantRetour = this.factureService.montantRetour(this.bordereauxR);
      this.montant = this.montantSansLesRetours - this.montantRetour;
      */


    });


    this.retourSettings = {
      actions: {
        columnTitle: '',
        position: 'left',
        add: this.editpermission,
        delete: this.editpermission,
        edit: this.editpermission, // on bloque l'édition pour faciliter ( obliger l'utilisateur à supprimer le flux pour le recréer ensuite avec une nouvelle valeur) la gestion des valeurs maximal de flux à saisir ( quantite qui depend de la quantité commandé et livré pour les retours )
      },
      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmCreate: true,
      },
      edit: {
        editButtonContent: '<i class="nb-search"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmSave: true,
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: true,
      },
      columns: {
        /* linkprint: {
          title: '',
          editable: false,
          addable: false,
          filter: false,
          type: 'custom',
          renderComponent: PrintlinkRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
        },*/
       /* id: {
          title: 'ID',
          type: 'text',
          editable: false,
          addable: false,
          filter: true,
          width: '0px',
          class: 'coloumClass',
        }, */
        refgene: {
          title: 'Numéro ',
          type: 'text',
          filter: false,
        },
        formatDateLivraison: {
          title: 'Date',
          type: 'html',
          filter: false,
        },
        etatBordereau: {
          title: 'Etat ',
          type: 'html',
          filter: false,
        },
        quantiteLivrer: {
          title: 'Produits',
          type: 'text',
          filter: false,
        },
      },
      mode: 'external',
      noDataMessage: 'Aucun bordereau trouvé',
      pager: {
        display: true, // pour gerer la pagination
        perPage: 10,
      },
    };

    // evenment de mise à jour du tableau des retour
    this.sourceRetour.onChanged().subscribe( (change) => {

      /* this.sourceCommande.getFilteredAndSorted().then( (cmd: Commande[]) => {

        this.qteCommande = this.factureService.quantiteCommande(cmd);

      }); */

      this.qteRetour = this.factureService.quantiteRetour(this.bordereauxR);

      this.montantSansLesRetours = this.factureService.montantSansLesRetours(this.commandes);
      this.montantRetour = this.factureService.montantRetour(this.bordereauxR);
      this.montant = (this.montantSansLesRetours + this.montantTaxe) - this.montantRetour;
      // this.montantReglement = this.factureService.montantReglement(this.reglements);


    });

    this.settingsReglement = {
      actions: {
        columnTitle: '',
        position: 'left',
        add: this.editpermission,
        edit: false,
        delete: this.editpermission,
      },
      add: {
        addButtonContent: '<i class="nb-plus"></i>',
        createButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmCreate: true,
      },
      edit: {
        editButtonContent: '<i class="nb-edit"></i>',
        saveButtonContent: '<i class="nb-checkmark"></i>',
        cancelButtonContent: '<i class="nb-close"></i>',
        confirmSave: true,
      },
      delete: {
        deleteButtonContent: '<i class="nb-trash"></i>',
        confirmDelete: true,
      },
      columns: {
        /* id: {
          title: 'ID',
          type: 'number',
          editable: false,
          addable: false,
          filter: false,
        }, */
        formatDateFlux: {
          title: 'Date',
          type: 'string',
          filter: false,
        },
        /* nature_reglement: {
          title: 'Type',
          type: 'string',
          filter: false,
        }, */
        montant: {
          title: 'Montant',
          type: 'string',
          filter: false,
        },
        /* source: {
          title: 'Source',
          type: 'string',
          filter: false,
        }, */
        cash_session_name: {
          title: 'Compte',
          type: 'text',
          filter: false,
        },
        cash_session_account: {
          title: 'Utilisateur',
          type: 'text',
          filter: false,
        },
        /* type_session: {
          title: 'Type',
          type: 'text',
        }, */
        /* cash_session_id: {
          title: 'Session',
          type: 'string',
          filter: false,
        }, */
      },
      hideSubHeader: false,
      noDataMessage: 'Aucun versement effectué',
      mode: 'external',
      pager: {
        display: false,
      },
    };

    // evenment de mise à jour du tableau des retour
    this.sourceReglement.onChanged().subscribe( (change) => {

      /* this.sourceCommande.getFilteredAndSorted().then( (cmd: Commande[]) => {

        this.qteCommande = this.factureService.quantiteCommande(cmd);

      }); */

      /* this.montantSansLesRetours = this.factureService.montantSansLesRetours(this.commandes);
      this.montant = this.montantSansLesRetours - this.factureService.montantRetour(this.bordereauxR); */
      this.montantReglement = this.factureService.montantReglement(this.reglements);
      


    });


    this.init();

  }


  getMontantTaxe(){

    this.montantTaxe = 0;

    if( this.facture.taxes !== undefined && this.facture.taxes !== null) {
      this.facture.taxes.forEach( elem => {
        this.montantTaxe += this.factureService.montantTaxe( elem, (this.montantHT-this.montantEmballage), (this.montantSansLesRetours-this.montantEmballage), this.qteCommande);
      })
    }

  }


  init() {


      this.dropdownSettings = {
        singleSelection: true,
        idField: 'id',
        textField: 'nom',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'recherche',
        noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
        closeDropDownOnSelection: true,
      };

      this.dropdownSettingsCompte = {
        singleSelection: true,
        idField: 'id',
        textField: 'labelNomSelect',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'recherche',
        noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
        closeDropDownOnSelection: true,
      };


      this.dropdownSettingsResp = {
        singleSelection: true,
        idField: 'id',
        textField: 'nom',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        searchPlaceholderText: 'recherche',
        noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
        closeDropDownOnSelection: true,
      };


      // chargement des parteanires taxe
      /* if ( this.taxeService.taxes !== undefined && this.taxeService.taxes.length === 0 ) {

        // this.partnerLoading = true;

        this.taxeService.getTaxes().then( taxes => {


        });


      } */ 

      // chargement des parteanires
      /* if (this.partenaireService.getLocalPartner(this.typePartner) === undefined) {

        this.loadPartner();

      } else {

          this.dropdownList = this.partenaireService.getLocalPartner(this.typePartner);

          if (this.facture.partenaire !== undefined) {
            this.selectedItems = [this.facture.partenaire];
          }

      }

      if(this.typePartner === 'fournisseur' && this.facture.partenaire !== undefined)
      this.produitService.defaultfournisseur = this.facture.partenaire; */


      // chargement des resp
      /* if(this.facture.type_facture === 'vente') {

        if (this.partenaireService.getLocalPartner('vendeur') === undefined) {

            this.loadVendeur();

        } else {

            this.dropdownListResp = this.partenaireService.getLocalPartner('vendeur');

            if (this.facture.resp !== undefined) {
              this.selectedItemsResp = [this.facture.resp];
            }

        }

      } */
      



      // chargement compte trésererie

      /* if ( this.cashSessionService.sessions === undefined) {

        let user: string;
        if (this.authService.token.user.id === null || this.authService.token.user.id === 0 || this.authService.token.user.id === undefined) {
          user = '';
        } else {
          user = this.authService.token.user.id.toString();
        }

        this.cashSessionService.getSessions('', '', user, 'all').then( sessions => {

          const pat = [];

          sessions.forEach( elem => {

            if ( elem.nature === 'espece' || elem.nature === 'banque' || elem.nature === 'depot') {

              pat.push( elem);

            }

          });

          this.dropdownListCompte = plainToClass( CashSession, pat);

        });

      } else {

        const pat = [];

        this.cashSessionService.sessions.forEach( elem => {

          if ( elem.nature === 'espece' || elem.nature === 'banque' || elem.nature === 'depot') {

            pat.push( elem);

          }

        });

        this.dropdownListCompte = plainToClass( CashSession, pat);
      } */



      this.printlink = '/pages/facture/' + this.facture.type_facture + '/print/' + this.facture.id;
      // tslint:disable-next-line:no-console
      // console.log(this.facture);

      if (this.commandes !== undefined && this.commandes !== null) {
        this.sourceCommande.load(plainToClass(Commande, this.commandes));
        // this.commandes = plainToClass(Commande, this.facture.commandes);
      }

      /* if (this.bordereauxR !== undefined && this.bordereauxR !== null)
      this.sourceRetour.load(plainToClass(Bordereau, this.bordereauxR));

      if (this.bordereauxL !== undefined && this.bordereauxL !== null)
      this.sourceBordereau.load(plainToClass(Bordereau , this.bordereauxL));

      if (this.reglements !== undefined)
      this.sourceReglement.load(plainToClass(Reglement, this.reglements)); */

      


  }

  loadPartner() {

      this.partnerLoading = true;

      this.partenaireService.getPartner(this.typePartner).then( partners => {

          this.dropdownList = partners;

          if (this.facture.partenaire !== undefined) {
            this.selectedItems = [this.facture.partenaire];
          }

          this.partnerLoading = false;

      });

  }

  loadVendeur() {

    this.vendeurLoading = true;

    this.partenaireService.getPartner('vendeur').then( partners => {

        this.dropdownListResp = partners;

        if (this.facture.resp !== undefined) {
          this.selectedItemsResp = [this.facture.resp];
        }

        this.vendeurLoading = false;

    });

}


  refreshCurrent() {

     this.dialogIsNotShow = true;
     this.factureService.getFacture(this.facture.id).then ( facture => {

        this.refreshObjets(facture);

        this.init();
        this.dialogIsNotShow = false;

    });

  }

  onItemSelect(item: any) {
    
    this.facture.partenaire = item;
    // recuperation de l'entité partenaire entière car on en aura besoin pour les prix
    for ( let i = 0; i < this.partenaireService.getLocalPartner(this.typePartner).length; i++) {

      if (this.partenaireService.getLocalPartner(this.typePartner)[i].id === item.id ) {

        this.facture.partenaire = this.partenaireService.getLocalPartner(this.typePartner)[i];
        // recuperation infos par defaut de facturation 
        this.facture.nom_facturation = this.facture.partenaire.nom;
        this.facture.tel_facturation = this.facture.partenaire.tel;
        this.facture.pays_facturation = this.facture.partenaire.pays;
        this.facture.ville_facturation = this.facture.partenaire.ville;
        this.facture.adresse_facturation = this.facture.partenaire.adresse;
        
        if(this.typePartner === 'fournisseur')
        this.produitService.defaultfournisseur = this.partenaireService.getLocalPartner(this.typePartner)[i];

        // if(this.authService.token.company.gestion_taxes)
        this.facture.taxes = this.partenaireService.getLocalPartner(this.typePartner)[i].taxes;

      }

    }

  }

  onDeSelect(item: any) {
    this.facture.partenaire = undefined;
  }

  onSelectAll(items: any) {
    // tslint:disable-next-line:no-console
    console.log(items);
  }

  onItemSelectCompte(item: any) {

    this.idcompte = item.id;
    // tslint:disable-next-line:no-console
    console.log(this.idcompte);
  }

  onDeSelectCompte(item: any) {
    this.idcompte = undefined;
  }

  onSelectAllCompte(items: any) {
    // tslint:disable-next-line:no-console
    console.log(items);
  }


  onItemSelectResp(item: any) {
    
    this.facture.resp = item;
    // recuperation de l'entité partenaire entière car on en aura besoin pour les prix
    for ( let i = 0; i < this.partenaireService.getLocalPartner(this.typePartner).length; i++) {

      if (this.partenaireService.getLocalPartner(this.typePartner)[i].id === item.id ) {

        this.facture.resp = this.partenaireService.getLocalPartner(this.typePartner)[i];

      }

    }

  }

  onDeSelectResp(item: any) {
    this.facture.resp = undefined;
  }

  onSelectAllResp(items: any) {
    // tslint:disable-next-line:no-console
    console.log(items);
  }

  addAccount() {

    const session = new CashSession;
    session.nature = 'espece';

    const closeOnBackdropClick = false;
    this.dialogService.open(SessionFormComponent, {
      closeOnBackdropClick,
      context: {
        sessionEdit: plainToClass(CashSession, session as object),
        naturesToExclude: ['credit'],
      },
    }).onClose.subscribe(data => {

        if ( data !== undefined ) {

          this.dropdownListCompte.push(plainToClass( CashSession, data as object));
          this.selectedItemsCompte = [plainToClass( CashSession, data as object)];
          this.idcompte = data.id;

        }

    });

  }




  confirmeSaveFacture(validate: boolean, type: string) {

    if (!this.factureService.iSsaving) {

      this.validate = validate;
      if ( validate && type === 'validate' ) {

          swal({
            title: 'Validation Vente',
            text: 'Vous êtes sur le point de valider cette commande. Cette action n\'est pas réversible. Vous ne pourrez plus la modifier, ni la supprimer. Confirmez-vous cette action ?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Annuler',
            confirmButtonText: 'Confirmer',
            showLoaderOnConfirm: true,
            allowOutsideClick: false,

          }).then((result) => {

            if (result.value) {

              this.saveFacture(validate);

            }

          });

      } else {

        this.saveFacture(validate);

      }

    }

  }

  refreshObjets( facture: Facture) {

    this.commandes = plainToClass(Commande, facture.commandes);
    this.bordereauxL = plainToClass(Bordereau, facture.bordereaux_livraison );
    this.bordereauxR = plainToClass(Bordereau, facture.bordereaux_retour );
    this.reglements = plainToClass(Reglement, facture.reglements );

    if (this.commandes !== undefined && this.commandes !== null) {
      this.sourceCommande.load(plainToClass(Commande, this.commandes));
      // this.commandes = plainToClass(Commande, this.facture.commandes);
    }

    if (this.bordereauxR !== undefined && this.bordereauxR !== null)
    this.sourceRetour.load(plainToClass(Bordereau, this.bordereauxR));

    if (this.bordereauxL !== undefined && this.bordereauxL !== null)
    this.sourceBordereau.load(plainToClass(Bordereau , this.bordereauxL));

    if (this.reglements !== undefined)
    this.sourceReglement.load(plainToClass(Reglement, this.reglements));



    this.factureService.invoiceSelected = plainToClass(Facture, Object.assign({}, facture) as object);


    facture.commandes = [];
    facture.bordereaux_livraison  = [];
    facture.bordereaux_retour = [];
    facture.reglements = [];

    this.facture = facture;

    if( (facture.repeat_date !== undefined && facture.repeat_date !== null) || (facture.repeat_period !== undefined && facture.repeat_period !== null) || facture.repeat_period === '' )
    this.facture.repeat = true;

  }

  saveFacture(validate: boolean): void {

    /* console.log( this.facture.taxes );
    return; */

    // alert(JSON.stringify(this.datefacture.date));
    // this.facture.date_facturation = this.sharedMethods.converNgbDateStructToString(this.datefacture);
    // this.facture.date_echeance = this.sharedMethods.converNgbDateStructToString(this.echeanceFacture);

    // on se raasure que le service n'est pas entrain d'effectuer une autre opération
    if (!this.factureService.iSsaving) {

      let valid: Validator;

      valid = this.sharedMethods.validateFacture(this.facture, validate, this.commandes, this.idcompte);

      if (valid.result) {

        // alert(JSON.stringify(this.sharedMethods.converStringToDatetime(this.facture.date_facturation)));

        // restauration date et heure
        if ( this.datePart !== undefined) {
          this.facture.date_facturation  = this.datePart;
  
          if ( this.timePart !== undefined)
          this.facture.date_facturation  += ' ' + this.timePart;
        }

        if ( this.repeatDatePart !== undefined) {
          this.facture.repeat_date  = this.repeatDatePart;
  
          if ( this.repeatTimePart !== undefined)
          this.facture.repeat_date  += ' ' + this.repeatTimePart;
        }

        this.dialogIsNotShow = true;

        this.factureService.saveFactureAndFlux(this.facture, this.commandes, this.facture.type_facture, validate, this.idcompte).then( facture => {

          this.dialogIsNotShow = false;
          this.refreshObjets(facture);

          // this.activeModal.dismiss(this.generateFacture());

          // this.sendSaveEvent();
          this.isSave = true;

          // this.close();

          let message = '';
          if ( this.facture.type_facture === 'vente') {

            if ( this.facture.valider)
            message = 'Vente Validée';
            else
            message = 'Vente Enregistrée';

          }


          if ( this.facture.type_facture === 'achat') {
            if ( this.facture.valider)
            message = 'Achat Validée';
            else
            message = 'Achat Enregistrée';
          }


          this.sharedMethods.toastShow('success', 'Success', message);


        });

        /* this.factureService.saveFactureAndFlux(this.facture, this.facture.type_facture).then( facture => {

          this.dialogIsNotShow = false;

        }); */


      } else {

          this.sharedMethods.toastShow('error', valid.title, valid.message);

      }


    }

  }

  generateFacture(): Facture {

    const facToSend = plainToClass(Facture, Object.assign({}, this.facture ) as object);

    facToSend.commandes = this.commandes;
    facToSend.bordereaux_livraison = this.bordereauxL;
    facToSend.bordereaux_retour = this.bordereauxR;
    facToSend.reglements = this.reglements;

    this.factureService.invoiceSelected = facToSend;

    return facToSend;

  }

  /* sendSaveEvent() {

    this.factureService.saveFactureEvent.next({
      row: this.rowData,
      facture: this.generateFacture(),
      typeEdit: this.typeEdit,
    });

  } */


  close() {

    if (!this.factureService.iSsaving) {

      if (this.isSave)
      this.activeModal.dismiss(this.generateFacture());
      else
      this.activeModal.dismiss();

    }

  }


  onDeleteCommande(event): void {

    if ( event.data.id !== 0 && event.data.id !== undefined) {

      const itemIndex = this.commandes.findIndex(item => item.id === event.data.id);
      this.commandes.splice(itemIndex, 1);

    } else {

      const itemIndex = this.commandes.findIndex(item => item.produit.id === event.data.produit.id);

      this.commandes.splice(itemIndex, 1);

    }

    this.sourceCommande.remove(event.data);


    /******************************************* Mise à jour emballage ******************************************/
    let itemIndexPr = -1;
    if (this.produitService.produits !== undefined && this.produitService.produits !== null)
    itemIndexPr = this.produitService.produits.findIndex(item => item.id === event.data.produit.id);

    if ( itemIndexPr > -1) {

      const embal = this.produitService.produits[itemIndexPr].emballage;

      if (embal === null || embal === undefined )
      return;

      this.sourceCommande.getAll().then( elems => {

        // recuparation index emballage
        const itemIndexembal = elems.findIndex(item => item.produit.id === embal.id);

        if (itemIndexembal < 0 )
        return;

        const newscmd = plainToClass(Commande, elems[itemIndexembal] as object);
        newscmd.quantite = elems[itemIndexembal].quantite - event.data.quantite;

        // recuperation index commande emballage dans facture
        const itemIndexCmd = this.commandes.findIndex(item => item.produit.id === embal.id);

        if (newscmd.quantite > 0) {

          this.sourceCommande.update(elems[itemIndexembal], newscmd);

          this.commandes[itemIndexCmd] = newscmd;
        } else {

          this.sourceCommande.remove(elems[itemIndexembal]);
          this.commandes.splice(itemIndexCmd, 1);
        }


      });

    }


  }

  onDeleteRetour(event): void {

    const bordereau = event.data;

    // facture = event.data;

    // tslint:disable-next-line:no-console
    // console.log(facture);

    if ( bordereau.valider === true ) {

      this.sharedMethods.toastShow('error', 'Opération non autorisée', 'Retour validé');
      return;

    }

    swal({
      title: 'Suppression Retour',
      text: 'Voulez - vous vraiment supprimer ' + bordereau.refgene + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.bordereauService.deleteBordereau(bordereau, bordereau.type_bordereau).then( data => {
          // event.confirm.resolve(event.newData);
          // event.confirm.resolve();
          this.sourceRetour.remove(event.data);
          // this.dialogIsNotShow = false;
          const itemIndex = this.bordereauxR.findIndex(item => item.id === event.data.id);
          this.bordereauxR.splice(itemIndex, 1);

          // this.sendSaveEvent();
          this.isSave = true;

        });

      },
    }).then((result) => {

      if (result.value) {


        this.sharedMethods.sweetalert('success', 'Retour supprimé', '');

      }

      // this.dialogIsNotShow = false;

    });


  }



  onCreateCommande(event): void {

    /*
      let user  = new User();
      user.FirstName = event.newData.FirstName;
      user.LastName = event.newData.LastName;
      user.Username = event.newData.Username;
      user.Email = event.newData.Email;
      user.Age = event.newData.Age;
      user.Activated = event.newData.Activated;
    */

    const command = new Commande();

    command.facture = this.facture;

    this.editCommande( command, 'add');

  }

  onCreateRetour(event): void {

   /* this.fluxstockedit = new FluxStock();

   this.fluxstockedit.facture = this.facture;
   this.fluxstockedit.type_flux = this.typeFluxRetour;

   this.editFluxstock( this.fluxstockedit, 'add', 'retour', false); */

   const bordereau = new Bordereau;

   bordereau.type_bordereau = this.typeFluxRetour;

   this.editInfosBordereau(bordereau, 'add', bordereau.type_bordereau, 'retour');


  }


  onSaveCommande(event): void {

    let command = new Commande();
    command = event.data;
    command.facture = this.facture;
    // alert(JSON.stringify(this.fluxstockedit));
    this.editCommande( command, 'update');

  }

  onSaveRetour (event): void {


    const bordereau = event.data;


    this.editInfosBordereau(bordereau, 'update', bordereau.type_bordereau, 'retour');


  }


  editCommande(commande: Commande, typeEdit: string) {


    if ( this.facture.partenaire !== null && this.facture.partenaire !== undefined ) {

      const closeOnBackdropClick = false;
      this.dialogService.open(CommandeFormComponent, {
        closeOnBackdropClick,
        context: {
          commandeedit : commande,
        },
      }).onClose.subscribe(data => {

          if (data !== undefined) {

              if (typeEdit === 'update') {

                 this.updateCommande(commande, data);

              }

              if (typeEdit === 'add') {

                // ajout de la commande
                this.addCommande(data);

                // commande des emballages
                let emballage: Produit;

                const itemIndex = this.produitService.produits.findIndex(item => item.id === data.produit.id);
                emballage = plainToClass(Produit, this.produitService.produits[itemIndex].emballage as object);

                // console.log(this.produitService.produits[itemIndex]);

                if ( emballage !== null && emballage !== undefined) {

                  const cmdemballage = new Commande;

                  cmdemballage.produit = emballage;
                  cmdemballage.quantite = data.quantite;
                  cmdemballage.prix_unitaire = emballage.prix_detail;
                  // cd.tva = data.tva;

                  this.addCommande(cmdemballage);

                }



              }

              // mise des produits du fournisseur local pour ne pas être obliger de recharger
              if( this.facture.type_facture === 'achat' && this.produitService.defaultproduitCreate !== undefined) {

                if(this.facture.partenaire.produits === undefined)
                this.facture.partenaire.produits = [];

                const index = this.facture.partenaire.produits.findIndex( item => item.id === this.produitService.defaultproduitCreate.id);

                if(index === -1) {

                  this.facture.partenaire.produits.push(this.produitService.defaultproduitCreate);
                  const patner = this.partenaireService.getLocalPartner(this.typePartner);

                  const index = patner.findIndex(item => item.id === this.facture.partenaire.id)

                  if(index > -1) {

                    if(patner[index].produits === undefined || patner[index].produits === null)
                    patner[index].produits = [];

                    patner[index].produits.push(this.produitService.defaultproduitCreate);

                    this.partenaireService.setLocalPartner(this.typePartner, patner);
                    this.dropdownList = patner;
                  
                  }

                  
                }

                this.produitService.defaultproduitCreate = undefined;

              }


              // this.commandes = plainToClass(Commande, this.facture.commandes);


          }

      });

    } else {

      this.sharedMethods.toastShow('warning', this.labelPartner + ' non selectionné', 'Selectionnez  un ' + this.labelPartner + ' avant d\'ajouter une commande');

    }

  }

  updateCommande(commande: Commande, data: any) {

    if ( data.id !== 0 && data.id !== undefined) {
      // cas ou les flux on déjà été sauvegarder dans la bd
      const itemIndex = this.facture.commandes.findIndex(item => item.id === commande.id);
      this.facture.commandes[itemIndex] = plainToClass(Commande, data as object);

    } else {

          const newcmd =  plainToClass(Commande, data as object);

          const itemIndex = this.facture.commandes.findIndex(item => item.produit.id === commande.produit.id);

          this.facture.commandes[itemIndex] = newcmd;

    }


    this.sourceCommande.update(commande, data);

    // tslint:disable-next-line:no-console
    // console.log (this.facture.fluxstock[itemIndex]);
  }

  addCommande(data: any) {

    const newcmd =  plainToClass(Commande, data as object);

    // on verifie si le produit n'a pas encore été commandé pour mettre à jour la commande
    const cmdfind = this.factureService.cmdByProd(newcmd.produit.id, this.commandes);

    if ( cmdfind !== undefined && cmdfind.produit.nature === 'article') {

      // cette operation met déjà a jour la commande dans la facture donc plus besoin de metre à jour la commande après
      cmdfind.quantite += newcmd.quantite;

      if (newcmd.remise !== null && newcmd.remise !== undefined) {

        if (cmdfind.remise === null || cmdfind.remise === undefined)
        cmdfind.remise = 0;

        cmdfind.remise += newcmd.remise;

      }

      this.sourceCommande.load(plainToClass(Commande, this.commandes));


    } else {

      this.commandes.push(plainToClass(Commande, data as object));

      this.sourceCommande.append(data);


    }


  }

  onCreatePaie(event): void {

    /*
      let user  = new User();
      user.FirstName = event.newData.FirstName;
      user.LastName = event.newData.LastName;
      user.Username = event.newData.Username;
      user.Email = event.newData.Email;
      user.Age = event.newData.Age;
      user.Activated = event.newData.Activated;
    */

   this.reglementEdit = new Reglement;

   this.reglementEdit.facture = this.facture;
   this.reglementEdit.type_flux = this.typeFluxReglement;
   this.reglementEdit.nature_reglement = 'espèce';
   /* const today = new Date();
   this.reglementEdit.date_flux = today.toISOString().split('T')[0]; */

   this.editReglement( this.reglementEdit, 'add');

  }

  onSavePaie(event): void {

    /*
      let user  = new User();
      user.FirstName = event.newData.FirstName;
      user.LastName = event.newData.LastName;
      user.Username = event.newData.Username;
      user.Email = event.newData.Email;
      user.Age = event.newData.Age;
      user.Activated = event.newData.Activated;
    */

    // tslint:disable-next-line:no-console
    // console.log(event.data);

   this.reglementEdit = event.data;

   this.reglementEdit.facture = this.facture;
   this.reglementEdit.type_flux = this.typeFluxReglement;

   this.editReglement( this.reglementEdit, 'update');

  }

  onDeletePaie(event): void {


    if (event.data.close_cashstate) {

      this.sharedMethods.toastShow('error', 'Opération non autorisée', 'Session cloturée');
      return;
    }


    this.dialogIsNotShow = true;

    swal({
      title: 'Suppression Règlement',
      text: 'Voulez - vous vraiment supprimer le règlement de ' + event.data.montant + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.reglementService.deleteReglement(event.data).then( reglement => {

          this.sourceReglement.remove(event.data);

          const itemIndex = this.reglements.findIndex(item => item.id === event.data.id);
          this.reglements.splice(itemIndex, 1);

          this.isSave = true;

          // this.sendSaveEvent();

        });

      },
    }).then((result) => {

      if (result.value) {


        this.sharedMethods.sweetalert('success', 'Règlement supprimé', '');

      }

      // this.dialogIsNotShow = false;


    });




  }

  editReglement(reglement: Reglement, typeEdit: string) {

    const closeOnBackdropClick = false;
    this.dialogService.open(ReglementFormComponent, {
      closeOnBackdropClick,
      context: {
        reglementEdit : this.reglementEdit,
        saveToApi: true,
        typePartner: this.typePartner,
      },
    }).onClose.subscribe(data => {

        if ( data !== undefined ) {

          if (typeEdit === 'update' ) {
            this.sourceReglement.update(this.reglementEdit, data);
            const itemIndex = this.reglements.findIndex(item => item.id === data.id);
            this.reglements[itemIndex] = plainToClass(Reglement, data as object);
          }

          if (typeEdit === 'add' ) {
            this.sourceReglement.append(data);

            if (this.reglements === undefined)
            this.reglements = [];
            this.reglements.push(plainToClass(Reglement, data as object));

          }

          this.isSave = true;

          /* this.dialogIsNotShow = true;
          this.factureService.getFacture(this.reglementEdit.facture.id).then( facture => {

            this.facture = facture;
            this.dialogIsNotShow = false;

          }); */



        }
    });

  }

  addpartner(typePartner: string, labelPartner: string) {
    const partner = new Partenaire;
    this.editPartner(partner, 'add', typePartner, labelPartner);
  }

  addtaxe() {
    const taxe = new Taxe;
    this.editTaxe(taxe, 'add');
  }

  editPartner(partner: Partenaire, typeEdit: string, typePartenaire: string, labelPartner: string) {

      const closeOnBackdropClick = false;
      this.dialogService.open(PartenaireFormComponent, {
        closeOnBackdropClick,
        context: {
          partenaireEdit : partner,
          typePartenaire : typePartenaire,
          labelPartner: labelPartner,
        },
      }).onClose.subscribe(data => {

          if ( data !== undefined) {

            // on met à jour la partenaire de la facture et le partenaire selectionner
            if( typePartenaire !== 'vendeur') {

              this.facture.partenaire = data;

              this.selectedItems = [
                data,
              ];

              const partner = this.dropdownList
              partner.push(data)

              this.dropdownList = partner;

            } else {

              this.facture.resp = data;

              this.selectedItemsResp = [
                data,
              ];

              const partner = this.dropdownListResp
              partner.push(data)

              this.dropdownListResp = partner;
            
            }
           

           /* if (typeEdit === 'update' )
            this.sourceReglement.update(this.reglementEdit, data);

            if (typeEdit === 'add' )
            this.sourceReglement.prepend(data); */

          }
      });
  }

  editTaxe(taxe: Taxe, typeEdit: string,) {

    const closeOnBackdropClick = false;
    this.dialogService.open(TaxeFormComponent, {
      closeOnBackdropClick,
      context: {
        taxeEdit : taxe,
      },
    }).onClose.subscribe(data => {

        if ( data !== undefined ) {


        }

    });
}


  onDeleteLivraison(event): void {

    const bordereau = event.data;

    // facture = event.data;

    // tslint:disable-next-line:no-console
    // console.log(facture);

    if ( bordereau.valider === true ) {

      this.sharedMethods.toastShow('error', 'Opération non autorisée', 'Livraison validé');
      return;

    }

    swal({
      title: 'Suppression  Livraison',
      text: 'Voulez - vous vraiment supprimer ' + bordereau.refgene + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.bordereauService.deleteBordereau(bordereau, bordereau.type_bordereau).then( data => {
          // event.confirm.resolve(event.newData);
          // event.confirm.resolve();
          this.sourceBordereau.remove(event.data);
          // this.dialogIsNotShow = false;
          const itemIndex = this.bordereauxL.findIndex(item => item.id === event.data.id);
          this.bordereauxL.splice(itemIndex, 1);

          // this.sendSaveEvent();

          this.isSave = true;

          this.facture.livrer = data.livraison_facture;


        });

      },
    }).then((result) => {

      if (result.value) {

        this.sharedMethods.sweetalert('success', 'Livraison supprimé', '');

      }

      // this.dialogIsNotShow = false;

    });

  }

  onCreateLivraison(event): void {

    const bordereau = new Bordereau;

    bordereau.type_bordereau = this.typeFlux;

    this.editInfosBordereau(bordereau, 'add', bordereau.type_bordereau, 'livraison');

  }

  onSaveLivraison(event): void {


    const bordereau = event.data;

    this.editInfosBordereau(bordereau, 'update', bordereau.type_bordereau, 'livraison');


  }


  editInfosBordereau(bordereauEdit: Bordereau, typeEdit: string, typeBordereau: string, saisir: string) {


      // bordereauEdit.fluxstock = [];

      const bordereau = plainToClass(Bordereau, Object.assign({}, bordereauEdit) as object);
      const fluxS = plainToClass(FluxStock, bordereau.fluxstock);
      bordereau.fluxstock = [];

      // bordereau = bordereauEdit;

      /* if (typeEdit === 'update') {

        if (saisir === 'livraison') {

          for ( let i = 0; i < this.bordereauxL.length; i++) {

            if (this.bordereauxL[i].id === bordereauEdit.id ) {
              bordereau = plainToClass(Bordereau, this.bordereauxL[i]);
            }

          }

        }


        if (saisir === 'retour') {

          for ( let i = 0; i < this.bordereauxR.length; i++) {

            if (this.bordereauxR[i].id === bordereauEdit.id ) {
              bordereau = plainToClass(Bordereau, this.bordereauxR[i]);
            }

          }

        }


      } */

      if (typeEdit === 'add') {

        // bordereau = bordereauEdit;
        bordereau.type_bordereau = typeBordereau;

      }

      bordereau.facture = this.facture;
      bordereau.reffac = this.facture.refgene;
      bordereau.datefac = this.facture.date_facturation;
      bordereau.typefac = this.facture.type_facture;

      const closeOnBackdropClick = false;

      this.dialogService.open(EditFormModalBordereauComponent, {
        closeOnBackdropClick,
        context: {
          bordereau : bordereau,
          typeSaisir: saisir,
          closeAfterSave: true,
          fluxstock: fluxS,
          // produit: pr,
        },
      }).onClose.subscribe( data => {

        if (data !== undefined && data !== null && data.id !== 0) {


          if (typeEdit === 'add' ) {

            if (saisir === 'livraison') {

                this.sourceBordereau.append(data);

                if (this.bordereauxL === undefined)
                this.bordereauxL = [];

                this.bordereauxL.push(plainToClass(Bordereau, data as object));
            }

            if (saisir === 'retour') {

                this.sourceRetour.append(data);

                if (this.bordereauxR === undefined)
                this.bordereauxR = [];

                this.bordereauxR.push(plainToClass(Bordereau, data as object));

            }

          }


          if (typeEdit === 'update' ) {

            if (saisir === 'livraison') {

                this.sourceBordereau.update(bordereauEdit, data);
                const itemIndex = this.bordereauxL.findIndex(item => item.id === data.id);
                this.bordereauxL[itemIndex] = plainToClass(Bordereau, data as object);
                // tslint:disable-next-line:no-console
                // console.log (this.facture.fluxstock[itemIndex]);
            }

            if (saisir === 'retour') {

              this.sourceRetour.update(bordereauEdit, data);
              const itemIndex = this.bordereauxR.findIndex(item => item.id === data.id);
              this.bordereauxR[itemIndex] = plainToClass(Bordereau, data as object);

            }

          }

          // mise à jour etat livraison facture
          this.facture.livrer = data.livraison_facture;

          this.isSave = true;


        }

      });

  }


  toggleDirection(newDirection) {
    // this.directionService.setDirection(newDirection);
    // tslint:disable-next-line:no-console
    // console.log(newDirection);
    this.facture.livrer = newDirection;
  }

  toggleDirectionPay(newDirection) {
    // this.directionService.setDirection(newDirection);
    // tslint:disable-next-line:no-console
    // console.log(newDirection);
    this.facture.payer = newDirection;
  }

  toggleDirectionRepeat(newDirection) {
    // this.directionService.setDirection(newDirection);
    // tslint:disable-next-line:no-console
    // console.log(newDirection);
    this.facture.repeat = newDirection;
    if(this.facture.repeat === false) {
      this.facture.repeat_period = null;
      this.facture.repeat_date = null;
    }

    if(this.facture.repeat === true) {
      this.facture.repeat_period = 'day';
    }

  }

  /* print() {
    this.dialogIsNotShow = false;
    this.modalRef = this.modalService.open(PrintFormModalComponent, { centered: true, backdrop: 'static',  size: 'lg', windowClass: 'print-modal-xxl' });
    this.modalRef.componentInstance.id = this.facture.id;
  } */


  ngOnDestroy() {
    // clearInterval(this.intervalId);
    this.alive = false;
    // this.settingService.getCurrentDay();
    // alert('');

    this.produitService.defaultfournisseur = undefined;


    if (this.modalRef !== undefined)
    this.modalRef.close();

    swal.close();


  }

  captureScreen(content: string) {

    const data = document.getElementById(content);

    const printContents = document.getElementById(content).innerHTML;
    const wLeft = window.screenLeft ? window.screenLeft : window.screenX;
    const wTop = window.screenTop ? window.screenTop : window.screenY;

    const left = wLeft + (window.innerWidth / 2) - (1000 / 2);
    const top = wTop + (window.innerHeight / 2) - (1000 / 2);

    // const popupWin = window.open('', '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=1000, height=1000, top=' + top + ', left=' + left);
    const popupWin = window.open('', '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=' + screen.width + ', height=' + screen.height + ', top=0, left=0');
    popupWin.focus();
    popupWin.document.open();
    const styleIsprintClass = '<style>.isprint{ display: block; } </style>';

    if ( this.deviceService.isMobile() || this.deviceService.isTablet() ) {
      popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="assets/style/invoice.css" /> ' + styleIsprintClass + '</head><body>' + printContents + '</body></html>');
    } else {
      popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="assets/style/invoice.css" /> ' + styleIsprintClass + '</head><body onload="window.print()">' + printContents + '</body></html>');
    }

    popupWin.document.close();

    /*const doc = new jspdf();

    doc.fromHTML(data, 15, 15, {
        'width': 170,
            'elementHandlers': specialElementHandlers
    });
    doc.save('sample-file.pdf'); */

    /* html2canvas(data).then(canvas => {
      // Few necessary setting options
      const imgWidth = 210; // with d'un format A4 (21cm * 29,7cm) les dimensions sont en mm ( paramètre du constructeur new jspdf())
      const pageHeight = 297;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      const heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL('image/png');
      // new JsPDF(
          // Orientation, // l (Landscape) or p (Portrait)
          // unit, // mm, cm, in
          // format // A2, A4 etc
      // );
      const pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
      const position = 10;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      pdf.save('MYPdf.pdf'); // Generated PDF

    }); */

  }

  
  

  checkTaxe(checked: boolean, data: Taxe) {

      // console.log(event);
      const indexTaxe = this.taxeIndex(data);
      
      if( indexTaxe > -1) {
        // console.log(data);
        if(!checked) {
          this.facture.taxes.splice(indexTaxe, 1);
        }

      } else {

        if(checked) {

          if(this.facture.taxes === undefined || this.facture.taxes === null)
          this.facture.taxes = [];

          this.facture.taxes.push(data);
    
        }
        
      }

      this.getMontantTaxe();
  }

  taxeIndex(taxe: Taxe): number {

      // console.log(event);
      //this.facture
      if(this.facture.taxes !== undefined && this.facture.taxes !== null)
      return this.facture.taxes.findIndex(item => item.id.toString() === taxe.id.toString());
      else
      return -1;
      
  }




}
